/**
 * Product Card Component
 * Gerencia interações dos cards de produto
 */
class ProductCard {
  constructor(card) {
    this.card = card;
    this.productId = card.dataset.productId;
    this.colors = card.querySelectorAll('.product-card__color');
    this.wishlistBtn = card.querySelector('.product-card__wishlist-btn');
    
    this.init();
  }

  init() {
    if (this.colors.length > 0) {
      this.setupColors();
    }
    
    if (this.wishlistBtn) {
      this.setupWishlist();
    }
    
    this.setupHoverEffects();
  }

  setupColors() {
    this.colors.forEach(color => {
      color.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Get the button element (pode ser o inner ou o button)
        const button = e.target.closest('.product-card__color');
        if (button) {
          this.selectColor(button);
        }
      });
    });
  }

  selectColor(selectedColor) {
    // Remove active state from all colors
    this.colors.forEach(color => {
      color.classList.remove('product-card__color--active');
    });
    
    // Add active state to selected color
    selectedColor.classList.add('product-card__color--active');
    
    // Update product image if needed
    const variantId = selectedColor.dataset.variantId;
    if (variantId) {
      this.updateProductImage(variantId);
    }
    
    // Update product price
    this.updateProductPrice(selectedColor);
  }

  updateProductImage(variantId) {
    const mainImg =
      this.card.querySelector('.product-card__image--primary') ||
      this.card.querySelector('.product-card__image');
    if (!mainImg) return;

    // Primeiro, tentar usar data-image-url do botão (mais rápido e confiável)
    const selectedButton = this.card.querySelector('.product-card__color--active');
    if (selectedButton && selectedButton.dataset.imageUrl) {
      mainImg.src = selectedButton.dataset.imageUrl;
      mainImg.alt = selectedButton.getAttribute('aria-label') || mainImg.alt;
      return; // Usar imagem do data attribute é mais rápido
    }

    // Fallback: usar imagem da miniatura
    if (selectedButton) {
      const thumbnailImg = selectedButton.querySelector('img');
      if (thumbnailImg && thumbnailImg.src) {
        mainImg.src = thumbnailImg.src.replace(/width=80/, 'width=600').replace(/height=80/, 'height=600');
        mainImg.alt = thumbnailImg.alt || mainImg.alt;
      }
    }

    // Opcionalmente, buscar via API para obter imagem de alta resolução (faz em background)
    fetch(`/variants/${variantId}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(variant => {
        if (variant && variant.featured_image && variant.featured_image.src) {
          // Só atualizar se a URL for diferente (mais alta resolução)
          if (mainImg.src !== variant.featured_image.src) {
            mainImg.src = variant.featured_image.src;
            mainImg.alt = variant.featured_image.alt || variant.name;
          }
        }
      })
      .catch(error => {
        console.log('Error updating image from API:', error);
        // A imagem do data attribute ou miniatura já foi aplicada
      });
  }

  updateProductPrice(selectedColor) {
    const priceContainer = this.card.querySelector('.product-card__price');
    if (!priceContainer) return;

    const priceElement = priceContainer.querySelector('.product-card__price--current');
    const comparePriceElement = priceContainer.querySelector('.product-card__price--compare');
    
    if (!priceElement) return;

    // Obter preços do data attribute do botão selecionado
    const price = selectedColor.dataset.price;
    const comparePrice = selectedColor.dataset.comparePrice;

    if (price) {
      // Converter de centavos para formato monetário
      const priceInReais = parseFloat(price) / 100;
      
      // Formatar como moeda brasileira
      const formattedPrice = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(priceInReais);

      // Atualizar preço atual
      priceElement.textContent = formattedPrice;
      priceElement.dataset.price = price;

      // Atualizar preço comparativo se existir e for maior que o preço atual
      if (comparePrice && comparePriceElement) {
        const comparePriceInReais = parseFloat(comparePrice) / 100;
        const comparePriceFormatted = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(comparePriceInReais);

        if (parseFloat(comparePrice) > parseFloat(price)) {
          comparePriceElement.textContent = comparePriceFormatted;
          comparePriceElement.dataset.comparePrice = comparePrice;
          comparePriceElement.style.display = '';
        } else {
          comparePriceElement.style.display = 'none';
        }
      } else if (comparePriceElement) {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  setupWishlist() {
    // O wishlist-manager.js agora cuida de toda a lógica de wishlist
    // Removemos o listener daqui para evitar conflito
    // O botão tem data-wishlist-toggle que é detectado pelo wishlist-manager.js
  }

  setupHoverEffects() {
    this.card.addEventListener('mouseenter', () => {
      this.card.classList.add('product-card--hover');
    });
    
    this.card.addEventListener('mouseleave', () => {
      this.card.classList.remove('product-card--hover');
    });
  }
}

// Inicializar cards quando o DOM estiver pronto
function initProductCards() {
  const cards = document.querySelectorAll('.product-card');
  cards.forEach(card => {
    // Verificar se o card já foi inicializado
    if (!card.dataset.initialized) {
      new ProductCard(card);
      card.dataset.initialized = 'true';
    }
  });
}

// Inicializar no DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCards);
} else {
  // DOM já carregado
  initProductCards();
}

// Exportar para uso global se necessário
window.ProductCard = ProductCard;
window.initProductCards = initProductCards;
